// extracted by mini-css-extract-plugin
export default {"emailconfigpanel-textbox-style":"EmailConfigPanel_emailconfigpanel-textbox-style__+Ua7g","emailconfigpanel-settings-text":"EmailConfigPanel_emailconfigpanel-settings-text__b8z4U"};